import { faCircleInfo } from '@fortawesome/pro-regular-svg-icons/faCircleInfo';
import React from 'react';

import { QIcon, QStack, QText } from '@captivateiq/quotient';

// Shared between IntroView and ChatView so wording/styling only needs to change in one place.
export const ExperimentalDisclaimer = () => (
  <QStack direction="row" spacing="5px" sx={{ alignItems: 'center', justifyContent: 'center' }}>
    <QIcon icon={faCircleInfo} sx={{ fontSize: '11px', color: 'text.onSurface.background.destructive' }} />
    <QText sx={{ color: 'text.onSurface.background.destructive', fontSize: '11px' }}>
      Experimental AI feature. Review all output and use at your own risk.
    </QText>
  </QStack>
);
